<form
  class="form --inline"
  [formGroup]="newsletterForm"
  (ngSubmit)="registerNewsletter()"
  >

  <app-text-form-field
    class="form__field --normal"
    [form]="newsletterForm"
    [controlName]="'fullName'"
    [formModel]="newsletter"
    [validators]="['pattern']"
    [options]="{
      label: 'homeOrga.firstAndLastName',
      pattern: nameRegex,
      trim: true
    }"
  />

  <app-text-form-field
    class="form__field --normal"
    [form]="newsletterForm"
    [controlName]="'email'"
    [formModel]="newsletter"
    [validators]="['required', 'email']"
    [asyncValidators]="[emailCheckValidator]"
    [options]="{
      label: 'homeOrga.email',
      trim: true,
    }"
  />

  <div class="buttons-group --centered --full-width-on-small">
    <button [disabled]="isSendingMessage" class="button --small" [ngClass]="style" type="submit" mat-button>
      {{ translations.subscribe }}
    </button>
  </div>

</form>

@for (error of errors; track error) {
  <mat-error class="mt-2 fs-16" [innerHTML]="'formErrors.' + error | transloco">
  </mat-error>
}